import { IGridUiAction } from "../base/AppGridToolbarActions_view";
import { BusinessAreasGridModel } from "./BusinessAreasGridView_model";

export const GetBusinessAreasGridActions = (model: BusinessAreasGridModel): IGridUiAction[] => {
  return [];
};
